import React, { useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import RoundButton from '../components/roundButton';
import { getQueryParam } from '../../services/commonService';
import ManifoldAssemblyNav from './ManifoldAssemblyNav';
import '../assets/css/left.css';
import NormalProductNav from './NormalProductNav';
import DynamicStackedNav from './DynamicStackedNav';
import StackedProductNav from './StackedProductNav';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';

const LeftSection = props => {
  const { dataItems, handleOnChange, sessionDataItems, imageUrls } = props;
  const queryParams = getQueryParam();
  const [sessionId, setSessionId] = React.useState(queryParams.get(''));
  const [startData, setStartData] = useState();
  const breakpoint = 768;
  const [width, setWidth] = useState(window.innerWidth);
  const [showFilter, setShowFilter] = useState(width >= breakpoint);
  const [feedbackDisplay, setFeedbackDisplay] = useState('flex');
  const [wrapperValue, setWrapperValue] = useState([]);
  const [option, setOption] = useState(0);

  useEffect(() => {
    /* Inside of a "useEffect" hook add an event listener that updates
       the "width" state variable when the window size changes */
    window.addEventListener('resize', () => setWidth(window.innerWidth));
    /* passing an empty array as the dependencies of the effect will cause this
       effect to only run when the component mounts, and not each time it updates.
       We only want the listener to be added once */
  }, []);

  useEffect(() => {
    width <= 768 ? setFeedbackDisplay('none') : setFeedbackDisplay('flex');
  }, [width]);
  useEffect(() => {
    setStartData(dataItems);
    let parameterPass =
      queryParams.get('controlandvaluestring') != null
        ? queryParams.get('controlandvaluestring')
        : queryParams.get('session') != null
        ? queryParams.get('session')
        : queryParams.get('Session');
    parameterPass =
      parameterPass != '' && parameterPass != null
        ? parameterPass
        : 'A6085FF6E126A6F16AC08FF7FF06EC4B';
    setSessionId(parameterPass);
  }, [props]);

  const isVE = () => {
    if (
      sessionDataItems?.landingPageUrl != null &&
      sessionDataItems?.landingPageUrl != '' &&
      sessionDataItems?.option == '97'
    )
      return true;
    else return false;
  };

  return (
    <Grid>
      {width < breakpoint ? (
        <Typography className="set-configuration-seriesname set-configuration-padding">
          {width < 768 ? sessionDataItems?.seriesName : ''}
          <RoundButton
            name="Set Configurations"
            classname="set-configuration"
            onClick={() => {
              setShowFilter(!showFilter);
              setFeedbackDisplay(feedbackDisplay == 'none' ? 'flex' : 'none');
            }}
          />
        </Typography>
      ) : (
        <></>
      )}
      {showFilter ? (
        <>
          <Grid className="set-configuration-below">
            {props.lang.SET_CONFIGURATIONS_BELOW}
          </Grid>
          {startData ? (
            startData?.isManifoldProduct ? (
              <ManifoldAssemblyNav
                startData={startData}
                lang={props.lang}
                handleOnChange={handleOnChange}
                sessionDataItems={sessionDataItems}
                handleIsManifoldSegmentStepEdited={
                  props.handleIsManifoldSegmentStepEdited
                }
                handleActiveTab={props.handleActiveTab}
                isVE={isVE()}
                isManifoldSegmentStepEdited={props.isManifoldSegmentStepEdited}
                activeTab={props.activeTab}
                handleStartData={props.handleStartData}
                handleIsStationEdit={props.handleIsStationEdit}
                isStationEdit={props.isStationEdit}
                editedStationMembers={props.editedStationMembers}
                handleEditeStationMembers={props.handleEditeStationMembers}
                editedManifoldSegmentforPrice={
                  props.editedManifoldSegmentforPrice
                }
                handleEditedManifoldSegmentforPrice={
                  props.handleEditedManifoldSegmentforPrice
                }
                handleManifoldPrices={props.handleManifoldPrices}
                handleRemovePrice={props.handleRemovePrice}
                editedWorkStation={props.editedWorkStation}
                handleEditedWorkStation={props.handleEditedWorkStation}
                handleDeleteSegmentEdited={props.handleDeleteSegmentEdited}
                isLoading={props.isLoading}
                handleSetCommits={props.handleSetCommits}
                commits={props.commits}
                handleCurrentSegmentName={props.handleCurrentSegmentName}
                handleIsCADValueChanged={props.handleIsCADValueChanged}
              />
            ) : startData?.isDynamicStackableProduct ? (
              <DynamicStackedNav
                startData={dataItems}
                isVE={isVE()}
                isLoading={props.isLoading}
                lang={props.lang}
                handleOnChange={handleOnChange}
                handleStartData={props.handleStartData}
                sessionDataItems={sessionDataItems}
                imageUrls={imageUrls}
              />
            ) : startData?.isNormalProduct ? (
              <NormalProductNav
                startData={dataItems}
                isVE={isVE()}
                lang={props.lang}
                handleOnChange={handleOnChange}
                imageUrls={imageUrls}
                sessionDataItems={sessionDataItems}
              />
            ) : (
              <StackedProductNav
                startData={startData}
                lang={props.lang}
                handleStartData={props.handleStartData}
                sessionDataItems={sessionDataItems}
                isLoading={props.isLoading}
                handleOnChange={handleOnChange}
                editedWorkStation={props.editedWorkStation}
                handleEditedWorkStation={props.handleEditedWorkStation}
                handleDeleteSegmentEdited={props.handleDeleteSegmentEdited}
                handleSetCommits={props.handleSetCommits}
                commits={props.commits}
              />
            )
          ) : (
            <div className="align-center api-error text-danger">
              <h5>
                <ReportProblemIcon />
              </h5>
              <h5>{props.lang.CONFIG_ENGINE_NOT_AVAILABLE}</h5>
            </div>
          )}
        </>
      ) : (
        <></>
      )}
    </Grid>
  );
};
export default LeftSection;
